import { Camera, Heart, History, ListChecks, Settings2, Wand2 } from 'lucide-react';

const features = [
    { icon: Camera, title: 'شناخت مواد از عکس', text: 'از مواد داخل آشپزخانه عکس بگیر، نتیجه را بررسی کن و قبل از ساخت غذا هر موردی را کم یا زیاد کن.', tone: 'coral' },
    { icon: ListChecks, title: 'دستور پخت کامل فارسی', text: 'مقدار مواد، مراحل مرتب، زمان پخت، تعداد نفرات، سختی، کالری تقریبی و هشدارهای لازم را یک‌جا ببین.', tone: 'green' },
    { icon: Settings2, title: 'طبق سلیقه و محدودیت تو', text: 'وعده، نوع غذا، رژیم، حساسیت، مواد غیرمجاز، زمان، تجهیزات و توضیح دلخواهت را مشخص کن.', tone: 'saffron' },
    { icon: Wand2, title: 'ویرایش هوشمند دستور', text: 'کربوهیدرات یا کالری را کم کن، چند ماده را جایگزین کن یا تغییر دلخواهت را بنویس؛ هر ویرایش مثل ساخت یک دستور تازه از اعتبارت کم می‌شود.', tone: 'coral' },
    { icon: Heart, title: 'علاقه‌مندی‌ها', text: 'دستورهایی را که دوست داری نشان کن تا در مجموعه شخصی‌ات همیشه در دسترس باشند.', tone: 'green' },
    { icon: History, title: 'تاریخچه دستورها', text: 'به دستورهای قبلی برگرد، جزئیات کاملشان را ببین و از همان‌جا دوباره ویرایششان کن.', tone: 'navy' },
];

const Features = () => (
    <section id="features" className="section features-section">
        <div className="site-container">
            <div className="section-heading">
                <span>هر چیزی که برای تصمیمِ «چی بپزم؟» لازم داری</span>
                <h2>از مواد پراکنده تا یک دستور پخت قابل اجرا</h2>
                <p>هوش‌پز فقط اسم غذا پیشنهاد نمی‌دهد؛ از انتخاب مواد تا شخصی‌سازی و نگهداری دستور کنارت می‌ماند.</p>
            </div>
            <div className="feature-grid">
                {features.map(({ icon: Icon, title, text, tone }) => (
                    <article className="feature-card" key={title}>
                        <div className={`feature-icon ${tone}`}><Icon size={25} /></div>
                        <h3>{title}</h3>
                        <p>{text}</p>
                    </article>
                ))}
            </div>
        </div>
    </section>
);

export default Features;
